import { Injectable } from '@angular/core';
import { I18nHelperService, TranslateService } from '@xref/ngx';
import { forkJoin, Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class CountryPhoneCodesService {

    static readonly MOST_USED_TRANSLATION_KEYS = [
        'Australia',
        'New Zealand',
        'Canada',
        'United Kingdom',
        'United States'
    ] as const;
    /** Emits when `countryList` / `mostUsedCountries` names are translated and sorted (initial load and after locale change). */
    readonly countriesReadySubject = new ReplaySubject<void>(1);
    readonly countriesReady$: Observable<void> = this.countriesReadySubject.asObservable();

    mostUsedCountries = [
        { isoCode: 'AU', translationKey: 'Australia', name: 'Australia', ext: '+61' },
        { isoCode: 'NZ', translationKey: 'New Zealand', name: 'New Zealand', ext: '+64' },
        { isoCode: 'CA', translationKey: 'Canada', name: 'Canada', ext: '+1' },
        { isoCode: 'GB', translationKey: 'United Kingdom', name: 'United Kingdom', ext: '+44' },
        { isoCode: 'US', translationKey: 'United States', name: 'United States', ext: '+1' },
    ];
    countryList = [
        { isoCode: 'AF', translationKey: 'Afghanistan', name: 'Afghanistan', ext: '+93' },
        { isoCode: 'AL', translationKey: 'Albania', name: 'Albania', ext: '+355' },
        { isoCode: 'DZ', translationKey: 'Algeria', name: 'Algeria', ext: '+213' },
        { isoCode: 'AS', translationKey: 'American Samoa', name: 'American Samoa', ext: '+1-684' },
        { isoCode: 'AD', translationKey: 'Andorra', name: 'Andorra', ext: '+376' },
        { isoCode: 'AO', translationKey: 'Angola', name: 'Angola', ext: '+244' },
        { isoCode: 'AI', translationKey: 'Anguilla', name: 'Anguilla', ext: '+1-264' },
        { isoCode: 'AQ', translationKey: 'Antarctica', name: 'Antarctica', ext: '+672' },
        { isoCode: 'AG', translationKey: 'Antigua and Barbuda', name: 'Antigua and Barbuda', ext: '+1-268' },
        { isoCode: 'AR', translationKey: 'Argentina', name: 'Argentina', ext: '+54' },
        { isoCode: 'AM', translationKey: 'Armenia', name: 'Armenia', ext: '+374' },
        { isoCode: 'AW', translationKey: 'Aruba', name: 'Aruba', ext: '+297' },
        { isoCode: 'AU', translationKey: 'Australia', name: 'Australia', ext: '+61' },
        { isoCode: 'AT', translationKey: 'Austria', name: 'Austria', ext: '+43' },
        { isoCode: 'AZ', translationKey: 'Azerbaijan', name: 'Azerbaijan', ext: '+994' },
        { isoCode: 'BS', translationKey: 'Bahamas', name: 'Bahamas', ext: '+1-242' },
        { isoCode: 'BH', translationKey: 'Bahrain', name: 'Bahrain', ext: '+973' },
        { isoCode: 'BD', translationKey: 'Bangladesh', name: 'Bangladesh', ext: '+880' },
        { isoCode: 'BB', translationKey: 'Barbados', name: 'Barbados', ext: '+1-246' },
        { isoCode: 'BY', translationKey: 'Belarus', name: 'Belarus', ext: '+375' },
        { isoCode: 'BE', translationKey: 'Belgium', name: 'Belgium', ext: '+32' },
        { isoCode: 'BZ', translationKey: 'Belize', name: 'Belize', ext: '+501' },
        { isoCode: 'BJ', translationKey: 'Benin', name: 'Benin', ext: '+229' },
        { isoCode: 'BM', translationKey: 'Bermuda', name: 'Bermuda', ext: '+1-441' },
        { isoCode: 'BT', translationKey: 'Bhutan', name: 'Bhutan', ext: '+975' },
        { isoCode: 'BO', translationKey: 'Bolivia', name: 'Bolivia', ext: '+591' },
        { isoCode: 'BA', translationKey: 'Bosnia and Herzegovina', name: 'Bosnia and Herzegovina', ext: '+387' },
        { isoCode: 'BW', translationKey: 'Botswana', name: 'Botswana', ext: '+267' },
        { isoCode: 'BR', translationKey: 'Brazil', name: 'Brazil', ext: '+55' },
        { isoCode: 'IO', translationKey: 'British Indian Ocean Territory', name: 'British Indian Ocean Territory', ext: '+246' },
        { isoCode: 'VG', translationKey: 'British Virgin Islands', name: 'British Virgin Islands', ext: '+1-284' },
        { isoCode: 'BN', translationKey: 'Brunei', name: 'Brunei', ext: '+673' },
        { isoCode: 'BG', translationKey: 'Bulgaria', name: 'Bulgaria', ext: '+359' },
        { isoCode: 'BF', translationKey: 'Burkina Faso', name: 'Burkina Faso', ext: '+226' },
        { isoCode: 'BI', translationKey: 'Burundi', name: 'Burundi', ext: '+257' },
        { isoCode: 'KH', translationKey: 'Cambodia', name: 'Cambodia', ext: '+855' },
        { isoCode: 'CM', translationKey: 'Cameroon', name: 'Cameroon', ext: '+237' },
        { isoCode: 'CA', translationKey: 'Canada', name: 'Canada', ext: '+1' },
        { isoCode: 'CV', translationKey: 'Cape Verde', name: 'Cape Verde', ext: '+238' },
        { isoCode: 'KY', translationKey: 'Cayman Islands', name: 'Cayman Islands', ext: '+1-345' },
        { isoCode: 'CF', translationKey: 'Central African Republic', name: 'Central African Republic', ext: '+236' },
        { isoCode: 'TD', translationKey: 'Chad', name: 'Chad', ext: '+235' },
        { isoCode: 'CL', translationKey: 'Chile', name: 'Chile', ext: '+56' },
        { isoCode: 'CN', translationKey: 'China', name: 'China', ext: '+86' },
        { isoCode: 'CX', translationKey: 'Christmas Island', name: 'Christmas Island', ext: '+61' },
        { isoCode: 'CC', translationKey: 'Cocos Islands', name: 'Cocos Islands', ext: '+61' },
        { isoCode: 'CO', translationKey: 'Colombia', name: 'Colombia', ext: '+57' },
        { isoCode: 'KM', translationKey: 'Comoros', name: 'Comoros', ext: '+269' },
        { isoCode: 'CK', translationKey: 'Cook Islands', name: 'Cook Islands', ext: '+682' },
        { isoCode: 'CR', translationKey: 'Costa Rica', name: 'Costa Rica', ext: '+506' },
        { isoCode: 'HR', translationKey: 'Croatia', name: 'Croatia', ext: '+385' },
        { isoCode: 'CU', translationKey: 'Cuba', name: 'Cuba', ext: '+53' },
        { isoCode: 'CW', translationKey: 'Curacao', name: 'Curacao', ext: '+599' },
        { isoCode: 'CY', translationKey: 'Cyprus', name: 'Cyprus', ext: '+357' },
        { isoCode: 'CZ', translationKey: 'Czech Republic', name: 'Czech Republic', ext: '+420' },
        { isoCode: 'CD', translationKey: 'Democratic Republic of the Congo', name: 'Democratic Republic of the Congo', ext: '+243' },
        { isoCode: 'DK', translationKey: 'Denmark', name: 'Denmark', ext: '+45' },
        { isoCode: 'DJ', translationKey: 'Djibouti', name: 'Djibouti', ext: '+253' },
        { isoCode: 'DM', translationKey: 'Dominica', name: 'Dominica', ext: '+1-767' },
        { isoCode: 'DO', translationKey: 'Dominican Republic (809)', name: 'Dominican Republic', ext: '+1-809' },
        { isoCode: 'DO', translationKey: 'Dominican Republic (829)', name: 'Dominican Republic', ext: '+1-829' },
        { isoCode: 'DO', translationKey: 'Dominican Republic (849)', name: 'Dominican Republic', ext: '+1-849' },
        { isoCode: 'TL', translationKey: 'East Timor', name: 'East Timor', ext: '+670' },
        { isoCode: 'EC', translationKey: 'Ecuador', name: 'Ecuador', ext: '+593' },
        { isoCode: 'EG', translationKey: 'Egypt', name: 'Egypt', ext: '+20' },
        { isoCode: 'SV', translationKey: 'El Salvador', name: 'El Salvador', ext: '+503' },
        { isoCode: 'GQ', translationKey: 'Equatorial Guinea', name: 'Equatorial Guinea', ext: '+240' },
        { isoCode: 'ER', translationKey: 'Eritrea', name: 'Eritrea', ext: '+291' },
        { isoCode: 'EE', translationKey: 'Estonia', name: 'Estonia', ext: '+372' },
        { isoCode: 'ET', translationKey: 'Ethiopia', name: 'Ethiopia', ext: '+251' },
        { isoCode: 'FK', translationKey: 'Falkland Islands', name: 'Falkland Islands', ext: '+500' },
        { isoCode: 'FO', translationKey: 'Faroe Islands', name: 'Faroe Islands', ext: '+298' },
        { isoCode: 'FJ', translationKey: 'Fiji', name: 'Fiji', ext: '+679' },
        { isoCode: 'FI', translationKey: 'Finland', name: 'Finland', ext: '+358' },
        { isoCode: 'FR', translationKey: 'France', name: 'France', ext: '+33' },
        { isoCode: 'PF', translationKey: 'French Polynesia', name: 'French Polynesia', ext: '+689' },
        { isoCode: 'GA', translationKey: 'Gabon', name: 'Gabon', ext: '+241' },
        { isoCode: 'GM', translationKey: 'Gambia', name: 'Gambia', ext: '+220' },
        { isoCode: 'GE', translationKey: 'Georgia', name: 'Georgia', ext: '+995' },
        { isoCode: 'DE', translationKey: 'Germany', name: 'Germany', ext: '+49' },
        { isoCode: 'GH', translationKey: 'Ghana', name: 'Ghana', ext: '+233' },
        { isoCode: 'GI', translationKey: 'Gibraltar', name: 'Gibraltar', ext: '+350' },
        { isoCode: 'GR', translationKey: 'Greece', name: 'Greece', ext: '+30' },
        { isoCode: 'GL', translationKey: 'Greenland', name: 'Greenland', ext: '+299' },
        { isoCode: 'GD', translationKey: 'Grenada', name: 'Grenada', ext: '+1-473' },
        { isoCode: 'GU', translationKey: 'Guam', name: 'Guam', ext: '+1-671' },
        { isoCode: 'GT', translationKey: 'Guatemala', name: 'Guatemala', ext: '+502' },
        { isoCode: 'GG', translationKey: 'Guernsey', name: 'Guernsey', ext: '+44-1481' },
        { isoCode: 'GN', translationKey: 'Guinea', name: 'Guinea', ext: '+224' },
        { isoCode: 'GW', translationKey: 'Guinea-Bissau', name: 'Guinea-Bissau', ext: '+245' },
        { isoCode: 'GY', translationKey: 'Guyana', name: 'Guyana', ext: '+592' },
        { isoCode: 'HT', translationKey: 'Haiti', name: 'Haiti', ext: '+509' },
        { isoCode: 'HN', translationKey: 'Honduras', name: 'Honduras', ext: '+504' },
        { isoCode: 'HK', translationKey: 'Hong Kong', name: 'Hong Kong', ext: '+852' },
        { isoCode: 'HU', translationKey: 'Hungary', name: 'Hungary', ext: '+36' },
        { isoCode: 'IS', translationKey: 'Iceland', name: 'Iceland', ext: '+354' },
        { isoCode: 'IN', translationKey: 'India', name: 'India', ext: '+91' },
        { isoCode: 'ID', translationKey: 'Indonesia', name: 'Indonesia', ext: '+62' },
        { isoCode: 'IR', translationKey: 'Iran', name: 'Iran', ext: '+98' },
        { isoCode: 'IQ', translationKey: 'Iraq', name: 'Iraq', ext: '+964' },
        { isoCode: 'IE', translationKey: 'Ireland', name: 'Ireland', ext: '+353' },
        { isoCode: 'IM', translationKey: 'Isle of Man', name: 'Isle of Man', ext: '+44-1624' },
        { isoCode: 'IL', translationKey: 'Israel', name: 'Israel', ext: '+972' },
        { isoCode: 'IT', translationKey: 'Italy', name: 'Italy', ext: '+39' },
        { isoCode: 'CI', translationKey: 'Ivory Coast', name: 'Ivory Coast', ext: '+225' },
        { isoCode: 'JM', translationKey: 'Jamaica', name: 'Jamaica', ext: '+1-876' },
        { isoCode: 'JP', translationKey: 'Japan', name: 'Japan', ext: '+81' },
        { isoCode: 'JE', translationKey: 'Jersey', name: 'Jersey', ext: '+44-1534' },
        { isoCode: 'JO', translationKey: 'Jordan', name: 'Jordan', ext: '+962' },
        { isoCode: 'KZ', translationKey: 'Kazakhstan', name: 'Kazakhstan', ext: '+7' },
        { isoCode: 'KE', translationKey: 'Kenya', name: 'Kenya', ext: '+254' },
        { isoCode: 'KI', translationKey: 'Kiribati', name: 'Kiribati', ext: '+686' },
        { isoCode: 'XK', translationKey: 'Kosovo', name: 'Kosovo', ext: '+383' },
        { isoCode: 'KW', translationKey: 'Kuwait', name: 'Kuwait', ext: '+965' },
        { isoCode: 'KG', translationKey: 'Kyrgyzstan', name: 'Kyrgyzstan', ext: '+996' },
        { isoCode: 'LA', translationKey: 'Laos', name: 'Laos', ext: '+856' },
        { isoCode: 'LV', translationKey: 'Latvia', name: 'Latvia', ext: '+371' },
        { isoCode: 'LB', translationKey: 'Lebanon', name: 'Lebanon', ext: '+961' },
        { isoCode: 'LS', translationKey: 'Lesotho', name: 'Lesotho', ext: '+266' },
        { isoCode: 'LR', translationKey: 'Liberia', name: 'Liberia', ext: '+231' },
        { isoCode: 'LY', translationKey: 'Libya', name: 'Libya', ext: '+218' },
        { isoCode: 'LI', translationKey: 'Liechtenstein', name: 'Liechtenstein', ext: '+423' },
        { isoCode: 'LT', translationKey: 'Lithuania', name: 'Lithuania', ext: '+370' },
        { isoCode: 'LU', translationKey: 'Luxembourg', name: 'Luxembourg', ext: '+352' },
        { isoCode: 'MO', translationKey: 'Macau', name: 'Macau', ext: '+853' },
        { isoCode: 'MK', translationKey: 'Macedonia', name: 'Macedonia', ext: '+389' },
        { isoCode: 'MG', translationKey: 'Madagascar', name: 'Madagascar', ext: '+261' },
        { isoCode: 'MW', translationKey: 'Malawi', name: 'Malawi', ext: '+265' },
        { isoCode: 'MY', translationKey: 'Malaysia', name: 'Malaysia', ext: '+60' },
        { isoCode: 'MV', translationKey: 'Maldives', name: 'Maldives', ext: '+960' },
        { isoCode: 'ML', translationKey: 'Mali', name: 'Mali', ext: '+223' },
        { isoCode: 'MT', translationKey: 'Malta', name: 'Malta', ext: '+356' },
        { isoCode: 'MH', translationKey: 'Marshall Islands', name: 'Marshall Islands', ext: '+692' },
        { isoCode: 'MR', translationKey: 'Mauritania', name: 'Mauritania', ext: '+222' },
        { isoCode: 'MU', translationKey: 'Mauritius', name: 'Mauritius', ext: '+230' },
        { isoCode: 'YT', translationKey: 'Mayotte', name: 'Mayotte', ext: '+262' },
        { isoCode: 'MX', translationKey: 'Mexico', name: 'Mexico', ext: '+52' },
        { isoCode: 'FM', translationKey: 'Micronesia', name: 'Micronesia', ext: '+691' },
        { isoCode: 'MD', translationKey: 'Moldova', name: 'Moldova', ext: '+373' },
        { isoCode: 'MC', translationKey: 'Monaco', name: 'Monaco', ext: '+377' },
        { isoCode: 'MN', translationKey: 'Mongolia', name: 'Mongolia', ext: '+976' },
        { isoCode: 'ME', translationKey: 'Montenegro', name: 'Montenegro', ext: '+382' },
        { isoCode: 'MS', translationKey: 'Montserrat', name: 'Montserrat', ext: '+1-664' },
        { isoCode: 'MA', translationKey: 'Morocco', name: 'Morocco', ext: '+212' },
        { isoCode: 'MZ', translationKey: 'Mozambique', name: 'Mozambique', ext: '+258' },
        { isoCode: 'MM', translationKey: 'Myanmar', name: 'Myanmar', ext: '+95' },
        { isoCode: 'NA', translationKey: 'Namibia', name: 'Namibia', ext: '+264' },
        { isoCode: 'NR', translationKey: 'Nauru', name: 'Nauru', ext: '+674' },
        { isoCode: 'NP', translationKey: 'Nepal', name: 'Nepal', ext: '+977' },
        { isoCode: 'NL', translationKey: 'Netherlands', name: 'Netherlands', ext: '+31' },
        { isoCode: 'AN', translationKey: 'Netherlands Antilles', name: 'Netherlands Antilles', ext: '+599' },
        { isoCode: 'NC', translationKey: 'New Caledonia', name: 'New Caledonia', ext: '+687' },
        { isoCode: 'NZ', translationKey: 'New Zealand', name: 'New Zealand', ext: '+64' },
        { isoCode: 'NI', translationKey: 'Nicaragua', name: 'Nicaragua', ext: '+505' },
        { isoCode: 'NE', translationKey: 'Niger', name: 'Niger', ext: '+227' },
        { isoCode: 'NG', translationKey: 'Nigeria', name: 'Nigeria', ext: '+234' },
        { isoCode: 'NU', translationKey: 'Niue', name: 'Niue', ext: '+683' },
        { isoCode: 'KP', translationKey: 'North Korea', name: 'North Korea', ext: '+850' },
        { isoCode: 'MP', translationKey: 'Northern Mariana Islands', name: 'Northern Mariana Islands', ext: '+1-670' },
        { isoCode: 'NO', translationKey: 'Norway', name: 'Norway', ext: '+47' },
        { isoCode: 'OM', translationKey: 'Oman', name: 'Oman', ext: '+968' },
        { isoCode: 'PK', translationKey: 'Pakistan', name: 'Pakistan', ext: '+92' },
        { isoCode: 'PW', translationKey: 'Palau', name: 'Palau', ext: '+680' },
        { isoCode: 'PS', translationKey: 'Palestine', name: 'Palestine', ext: '+970' },
        { isoCode: 'PA', translationKey: 'Panama', name: 'Panama', ext: '+507' },
        { isoCode: 'PG', translationKey: 'Papua New Guinea', name: 'Papua New Guinea', ext: '+675' },
        { isoCode: 'PY', translationKey: 'Paraguay', name: 'Paraguay', ext: '+595' },
        { isoCode: 'PE', translationKey: 'Peru', name: 'Peru', ext: '+51' },
        { isoCode: 'PH', translationKey: 'Philippines', name: 'Philippines', ext: '+63' },
        { isoCode: 'PN', translationKey: 'Pitcairn', name: 'Pitcairn', ext: '+64' },
        { isoCode: 'PL', translationKey: 'Poland', name: 'Poland', ext: '+48' },
        { isoCode: 'PT', translationKey: 'Portugal', name: 'Portugal', ext: '+351' },
        { isoCode: 'PR', translationKey: 'Puerto Rico (787)', name: 'Puerto Rico', ext: '+1-787' },
        { isoCode: 'PR', translationKey: 'Puerto Rico (939)', name: 'Puerto Rico', ext: '+1-939' },
        { isoCode: 'QA', translationKey: 'Qatar', name: 'Qatar', ext: '+974' },
        { isoCode: 'CG', translationKey: 'Republic of the Congo', name: 'Republic of the Congo', ext: '+242' },
        { isoCode: 'RE', translationKey: 'Reunion', name: 'Reunion', ext: '+262' },
        { isoCode: 'RO', translationKey: 'Romania', name: 'Romania', ext: '+40' },
        { isoCode: 'RU', translationKey: 'Russia', name: 'Russia', ext: '+7' },
        { isoCode: 'RW', translationKey: 'Rwanda', name: 'Rwanda', ext: '+250' },
        { isoCode: 'BL', translationKey: 'Saint Barthelemy', name: 'Saint Barthelemy', ext: '+590' },
        { isoCode: 'SH', translationKey: 'Saint Helena', name: 'Saint Helena', ext: '+290' },
        { isoCode: 'KN', translationKey: 'Saint Kitts and Nevis', name: 'Saint Kitts and Nevis', ext: '+1-869' },
        { isoCode: 'LC', translationKey: 'Saint Lucia', name: 'Saint Lucia', ext: '+1-758' },
        { isoCode: 'MF', translationKey: 'Saint Martin', name: 'Saint Martin', ext: '+590' },
        { isoCode: 'PM', translationKey: 'Saint Pierre and Miquelon', name: 'Saint Pierre and Miquelon', ext: '+508' },
        { isoCode: 'VC', translationKey: 'Saint Vincent and the Grenadines', name: 'Saint Vincent and the Grenadines', ext: '+1-784' },
        { isoCode: 'WS', translationKey: 'Samoa', name: 'Samoa', ext: '+685' },
        { isoCode: 'SM', translationKey: 'San Marino', name: 'San Marino', ext: '+378' },
        { isoCode: 'ST', translationKey: 'Sao Tome and Principe', name: 'Sao Tome and Principe', ext: '+239' },
        { isoCode: 'SA', translationKey: 'Saudi Arabia', name: 'Saudi Arabia', ext: '+966' },
        { isoCode: 'SN', translationKey: 'Senegal', name: 'Senegal', ext: '+221' },
        { isoCode: 'RS', translationKey: 'Serbia', name: 'Serbia', ext: '+381' },
        { isoCode: 'SC', translationKey: 'Seychelles', name: 'Seychelles', ext: '+248' },
        { isoCode: 'SL', translationKey: 'Sierra Leone', name: 'Sierra Leone', ext: '+232' },
        { isoCode: 'SG', translationKey: 'Singapore', name: 'Singapore', ext: '+65' },
        { isoCode: 'SX', translationKey: 'Sint Maarten', name: 'Sint Maarten', ext: '+1-721' },
        { isoCode: 'SK', translationKey: 'Slovakia', name: 'Slovakia', ext: '+421' },
        { isoCode: 'SI', translationKey: 'Slovenia', name: 'Slovenia', ext: '+386' },
        { isoCode: 'SB', translationKey: 'Solomon Islands', name: 'Solomon Islands', ext: '+677' },
        { isoCode: 'SO', translationKey: 'Somalia', name: 'Somalia', ext: '+252' },
        { isoCode: 'ZA', translationKey: 'South Africa', name: 'South Africa', ext: '+27' },
        { isoCode: 'KR', translationKey: 'South Korea', name: 'South Korea', ext: '+82' },
        { isoCode: 'SS', translationKey: 'South Sudan', name: 'South Sudan', ext: '+211' },
        { isoCode: 'ES', translationKey: 'Spain', name: 'Spain', ext: '+34' },
        { isoCode: 'LK', translationKey: 'Sri Lanka', name: 'Sri Lanka', ext: '+94' },
        { isoCode: 'SD', translationKey: 'Sudan', name: 'Sudan', ext: '+249' },
        { isoCode: 'SR', translationKey: 'Suriname', name: 'Suriname', ext: '+597' },
        { isoCode: 'SJ', translationKey: 'Svalbard and Jan Mayen', name: 'Svalbard and Jan Mayen', ext: '+47' },
        { isoCode: 'SZ', translationKey: 'Swaziland', name: 'Swaziland', ext: '+268' },
        { isoCode: 'SE', translationKey: 'Sweden', name: 'Sweden', ext: '+46' },
        { isoCode: 'CH', translationKey: 'Switzerland', name: 'Switzerland', ext: '+41' },
        { isoCode: 'SY', translationKey: 'Syria', name: 'Syria', ext: '+963' },
        { isoCode: 'TW', translationKey: 'Taiwan', name: 'Taiwan', ext: '+886' },
        { isoCode: 'TJ', translationKey: 'Tajikistan', name: 'Tajikistan', ext: '+992' },
        { isoCode: 'TZ', translationKey: 'Tanzania', name: 'Tanzania', ext: '+255' },
        { isoCode: 'TH', translationKey: 'Thailand', name: 'Thailand', ext: '+66' },
        { isoCode: 'TG', translationKey: 'Togo', name: 'Togo', ext: '+228' },
        { isoCode: 'TK', translationKey: 'Tokelau', name: 'Tokelau', ext: '+690' },
        { isoCode: 'TO', translationKey: 'Tonga', name: 'Tonga', ext: '+676' },
        { isoCode: 'TT', translationKey: 'Trinidad and Tobago', name: 'Trinidad and Tobago', ext: '+1-868' },
        { isoCode: 'TN', translationKey: 'Tunisia', name: 'Tunisia', ext: '+216' },
        { isoCode: 'TR', translationKey: 'Turkey', name: 'Turkey', ext: '+90' },
        { isoCode: 'TM', translationKey: 'Turkmenistan', name: 'Turkmenistan', ext: '+993' },
        { isoCode: 'TC', translationKey: 'Turks and Caicos Islands', name: 'Turks and Caicos Islands', ext: '+1-649' },
        { isoCode: 'TV', translationKey: 'Tuvalu', name: 'Tuvalu', ext: '+688' },
        { isoCode: 'VI', translationKey: 'U.S. Virgin Islands', name: 'U.S. Virgin Islands', ext: '+1-340' },
        { isoCode: 'UG', translationKey: 'Uganda', name: 'Uganda', ext: '+256' },
        { isoCode: 'UA', translationKey: 'Ukraine', name: 'Ukraine', ext: '+380' },
        { isoCode: 'AE', translationKey: 'United Arab Emirates', name: 'United Arab Emirates', ext: '+971' },
        { isoCode: 'GB', translationKey: 'United Kingdom', name: 'United Kingdom', ext: '+44' },
        { isoCode: 'US', translationKey: 'United States', name: 'United States', ext: '+1' },
        { isoCode: 'UY', translationKey: 'Uruguay', name: 'Uruguay', ext: '+598' },
        { isoCode: 'UZ', translationKey: 'Uzbekistan', name: 'Uzbekistan', ext: '+998' },
        { isoCode: 'VU', translationKey: 'Vanuatu', name: 'Vanuatu', ext: '+678' },
        { isoCode: 'VA', translationKey: 'Vatican', name: 'Vatican', ext: '+379' },
        { isoCode: 'VE', translationKey: 'Venezuela', name: 'Venezuela', ext: '+58' },
        { isoCode: 'VN', translationKey: 'Vietnam', name: 'Vietnam', ext: '+84' },
        { isoCode: 'WF', translationKey: 'Wallis and Futuna', name: 'Wallis and Futuna', ext: '+681' },
        { isoCode: 'EH', translationKey: 'Western Sahara', name: 'Western Sahara', ext: '+212' },
        { isoCode: 'YE', translationKey: 'Yemen', name: 'Yemen', ext: '+967' },
        { isoCode: 'ZM', translationKey: 'Zambia', name: 'Zambia', ext: '+260' },
        { isoCode: 'ZW', translationKey: 'Zimbabwe', name: 'Zimbabwe', ext: '+263' }
    ];

    constructor(
        private i18nHelper: I18nHelperService,
        private translate: TranslateService
    ) {
        this.i18nHelper.localeChanged$.subscribe(() => this.translateCountries());
        this.translateCountries();
    }

    getIsoCodeFromCountryName(countryName: string): string {
        const country = this.countryList.find(c => c.name === countryName);
        return country?.isoCode || 'AU'; // Default to AU if not found
    }

    getCountryCodeFromIsoCode(isoCode: string): string {
        const country = this.countryList.find(c => c.isoCode === isoCode);
        return country?.ext || '+61'; // Default to Australia (+61) if not found
    }

    private translateCountries() {
        const countryList = this.countryList.map(country => country);
        const translateObservables = [];

        for (let i = 0; i < countryList.length; i++)
            translateObservables.push(this.translate.get('countries.' + countryList[i].translationKey));

        forkJoin(translateObservables).subscribe({
            next: (value: string[]) => {
                for (let i = 0; i < countryList.length; i++) {
                    countryList[i].name = value[i];
                }
            },
            complete: () => {
                // Sort list based on translated name
                countryList.sort(function (a, b) {
                    return new Intl.Collator().compare(a.name, b.name);
                });

                this.countryList = countryList;
                this.getMostUsedCountries();
                this.countriesReadySubject.next();
            }
        });
    }

    private getMostUsedCountries() {
        this.mostUsedCountries = CountryPhoneCodesService.MOST_USED_TRANSLATION_KEYS.map(translationKey =>
            this.countryList.find(c => c.translationKey === translationKey)
        ).filter((c): c is NonNullable<typeof c> => c != null);
    }
}
